// eslint-disable-next-line no-unused-vars
import React, { memo, useEffect, useState } from 'react';
import { stringify } from 'query-string';
import { useForm } from 'react-hook-form';
import { omit } from 'lodash';
import { array, func, object } from 'prop-types';

import useUser from 'Hooks/useUser';
import useRouter from 'Hooks/useRouter';
import useScrollLock from 'Hooks/useScrollLock';
import FilterReservedProductsComponent from 'Components/ReservedProducts/FilterReservedProducts';
import useAnalytics from 'Hooks/useAnalytics';

const FilterReservedProducts = memo(({
  sortOptions,
  currentSort,
  handleMobileOrderChange,
}) => {
  const [mobileFiltersOpen, setMobileFiltersOpen] = useState(false);
  const [mobileSortOpen, setMobileSortOpen] = useState(false);
  const { data: { email, loggedIn } } = useUser();
  const { push, location, query } = useRouter();
  const analytics = useAnalytics();
  const {
    register,
    reset,
    getValues,
    setValue,
  } = useForm();

  useEffect(() => {
    // check if query has any filters and set them in the form
    if (Object.keys(omit(query || {}, ['order_by', 'order_direction', 'page'])).length) {
      Object.entries(query).forEach(([key, value]) => {
        setValue(key, value);
      });
    }
  }, [email, loggedIn]);

  useScrollLock(mobileFiltersOpen);

  const handleSubmit = () => {
    setMobileFiltersOpen(false);

    const formValues = getValues();

    const queryParams = Object.entries(formValues)
      // eslint-disable-next-line no-unused-vars
      .filter(([_, value]) => value)
      .reduce((acc, [key, value]) => {
        if (value !== 'false') {
          acc[key] = value;
        }
        return acc;
      }, {});

    const searchedValues = Object.keys(queryParams).join(', ');
    analytics.track('filter_reserved_products', { filters: searchedValues });

    push({
      location: location.pathname,
      search: stringify(queryParams)
    });
  };

  const handleClearFilters = () => {
    analytics.track('clear_filters');

    setMobileFiltersOpen(false);
    reset({
      order_number: '',
      product_code: '',
    });

    push({
      location: location.pathname,
      search: ''
    });
  };

  const onMobileOrderChange = sort => {
    analytics.track('mobile_sort');
    setMobileSortOpen(false);
    handleMobileOrderChange(sort);
  };

  const handleClearFilter = key => {
    analytics.track('filters_clear');
    setValue(key, '');
    push({
      location: location.pathname,
      search: stringify(omit(query, [key]))
    });
  };

  return (
    <FilterReservedProductsComponent
      register={ register }
      onSubmit={ handleSubmit }
      onClearFilters={ handleClearFilters }
      onClearFilter={ handleClearFilter }
      activeFilters={ omit(query || {}, ['order_by', 'order_direction', 'page']) }
      mobileFiltersOpen={ mobileFiltersOpen }
      setMobileFiltersOpen={ setMobileFiltersOpen }
      mobileSortOpen={ mobileSortOpen }
      setMobileSortOpen={ setMobileSortOpen }
      sortOptions={ sortOptions }
      currentSort={ currentSort }
      handleMobileOrderChange={ onMobileOrderChange }
    />
  );
});

FilterReservedProducts.propTypes = {
  sortOptions: array,
  currentSort: object,
  handleMobileOrderChange: func,
};

FilterReservedProducts.displayName = 'FilterReservedProductsContainer';

export default FilterReservedProducts;
